import {all, call, fork, put, takeEvery} from 'redux-saga/effects';
import {fetchJSON} from '../../../../../helpers/FetchUtils';
import {ACCOUNT_MEMBER_INVITE,} from './constants';
import {accountMemberInviteFail, accountMemberInviteSuccess,} from './actions';
import {layoutMainSignCheck} from "../../../layouts/main/actions";
import {catchError, showErrorToast} from "../../../../../util/ErrorCatchUtils";

//
function* accountMemberInvite({payload: {params}}) {
    try {
        const response = yield call(fetchJSON,
            '/api/account/corp/current/info', {method: 'GET'});
        if (response.success) {
            let responseData = response.data;
            yield put(accountMemberInviteSuccess({loadDatas: {...responseData}, params}));
        } else {
            yield put(layoutMainSignCheck({...response, showToast: true}));
            yield put(accountMemberInviteFail(response));
        }
    } catch (error) {
        yield put(layoutMainSignCheck(showErrorToast(error)));
        yield put(accountMemberInviteFail(catchError(error)));
    }
}

//
export function* accountMemberInviteWatcher() {
    yield takeEvery(ACCOUNT_MEMBER_INVITE, accountMemberInvite);
}

//
function* accountMemberInviteSaga() {
    yield all([
        fork(accountMemberInviteWatcher)]);
}

export default accountMemberInviteSaga;
